import { render, staticRenderFns } from "./addRefundExpress.vue?vue&type=template&id=2b22710d&scoped=true"
import script from "./addRefundExpress.vue?vue&type=script&lang=js"
export * from "./addRefundExpress.vue?vue&type=script&lang=js"
import style0 from "./addRefundExpress.vue?vue&type=style&index=0&id=2b22710d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22710d",
  null
  
)

export default component.exports